import Accordion from '@ben/orion/accordion';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { camelCase } from 'lodash';
import { useMemo } from 'react';

interface RestrictionGroupProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle?: (isOpen: boolean) => void;
}

const RestrictionGroup = ({
  title,
  children,
  isOpen,
  onToggle,
}: RestrictionGroupProps) => {
  const accordionValue = camelCase(title);

  const accordionOpenValue = useMemo(
    () => (isOpen ? [accordionValue] : []),
    [isOpen, accordionValue]
  );

  const handleChange = (newValue: string[]) => {
    const isCurrentlyOpen = newValue.includes(accordionValue);
    onToggle?.(isCurrentlyOpen);
  };

  return (
    <Accordion size="sm" value={accordionOpenValue} onChange={handleChange}>
      <Accordion.Item value={accordionValue}>
        <Accordion.Control>
          <Typography variant={TypographyVariant.bodySm2}>{title}</Typography>
        </Accordion.Control>
        <Accordion.Panel>{children}</Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default RestrictionGroup;
